module.exports = __webpack_public_path__ + "static/img/portrait-white.afd80ec4.png";